module.exports = __webpack_public_path__ + "static/media/british_flag.1ea76799.jpg";